import { mapDTO } from '@twistezo/ts-dto-mapper'
import _ from 'lodash'

import { Workspace } from 'features/workspace'
import { floatPercentToDTO } from 'utils/number'
import { AddOwnSchema } from '../../../schemas/addSchema'
import { Variables as VariablesDTO } from './types'

type From = AddOwnSchema & { workspaceId: Workspace['id'] }
type Variables = Pick<
  From,
  | 'bidCpmAdjustment'
  | 'bidderCode'
  | 'bidderId'
  | 'bidderSid'
  | 'consentMode'
  | 'priority'
  | 'workspaceId'
>

export const toDTO = (from: From): VariablesDTO =>
  mapDTO<From, VariablesDTO>({ from }).transform((data: From): VariablesDTO => {
    const variables: Variables = _.pick(data, [
      'bidCpmAdjustment',
      'bidderCode',
      'bidderSid',
      'bidderId',
      'consentMode',
      'priority',
      'workspaceId',
    ])

    const { bidCpmAdjustment, bidderId, bidderSid } = variables

    return {
      ...variables,
      bidCpmAdjustment: floatPercentToDTO(bidCpmAdjustment),
      bidderId: bidderId.value,
      bidderSid: bidderSid || null,
    }
  })
